import { makeStyles } from '@material-ui/core';

export default makeStyles(theme => ({
  closeButton: {
    position: 'absolute',
    top: 10,
    right: 10,
    padding: 8,
  },
  dialogActions: {
    padding: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1)
    }
  },
  dialogContent: {
    '&.flex': {
      display: 'flex',
    },

    [theme.breakpoints.down('sm')]: {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
    },

    '&.noPadding': {
      paddingLeft: 0,
      paddingRight: 0,
    }
  },
  dialogTitle: {
    fontSize: 20,
    fontFamily: 'Roboto-Bold',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
    },
  }
}));